import { Api } from '../AApi'

export const API_PROVINCE = new Api(
  {
    url: 'provinces',
    only: ['list'],
  },
  {
    importGdb: {
      async request(formData, onUploadProgress) {
        return this.sdk
          .request({
            method: 'post',
            url: 'provinces/import-gdb',
            data: formData,
            onUploadProgress,
          })
          .then((res) => res.data)
      },
    },
  }
)
